/* ------------------------------------------------------------------
   Snelle afrekenknoppen op de productpagina (.geo-product-express)
   Shopify toont op de productpagina standaard maar 1 knop (Shop Pay) + "Meer betalingsopties".
   Dit script zet de wallets die op het apparaat van de klant werken (Apple Pay, PayPal,
   Google Pay) naast elkaar, elk als eigen productknop (koopt het gekozen product/aantal).
   Shop Pay wordt niet getoond. De lijst met wallets komt uit Shopify's eigen
   winkelwagen-knoppen (in een <template>), zodat alleen werkende wallets verschijnen.
   De knoppen tonen alleen het logo, zonder 'Buy with' / 'Pay with' / 'Kopen met'.
------------------------------------------------------------------- */
(function () {
  /* Geen 'Buy with'-tekst in onze knoppen: alleen het logo (zoals in de winkelwagen) */
  const NO_CTA = ['shopify-paypal-button', 'shopify-google-pay-button', 'shopify-apple-pay-button'];
  const patch = (C) => {
    try {
      Object.defineProperty(C.prototype, 'isCTA', {
        get() {
          if (this.closest && this.closest('.geo-product-express__row')) return false;
          return this.hasAttribute('call-to-action');
        },
        configurable: true,
      });
    } catch (e) {}
  };
  NO_CTA.forEach((t) => {
    const C = customElements.get(t);
    if (C) patch(C);
  });
  const origDefine = customElements.define.bind(customElements);
  customElements.define = function (name, C, opts) {
    if (NO_CTA.includes(name)) patch(C);
    return origDefine(name, C, opts);
  };

  function build(box) {
    if (box.dataset.geoDone) return;
    const orig = box.querySelector('shopify-accelerated-checkout');
    const tpl = box.querySelector('template.geo-wallet-src');
    if (!orig || !tpl) return;
    box.dataset.geoDone = '1';
    const src = tpl.content.querySelector('shopify-accelerated-checkout-cart');
    if (!src) return;
    let cfg = [];
    try {
      cfg = JSON.parse(src.getAttribute('wallet-configs') || '[]');
    } catch (e) {
      return;
    }
    cfg = cfg.filter((c) => c.name !== 'shop_pay');
    if (!cfg.length) return;
    const row = document.createElement('div');
    row.className = 'geo-product-express__row';
    cfg.forEach((w) => {
      const t = document.createElement('template');
      t.innerHTML = orig.outerHTML;
      const el = t.content.firstElementChild;
      el.setAttribute('recommended', JSON.stringify(w));
      el.innerHTML = '';
      row.appendChild(el);
    });
    box.appendChild(row);
  }

  function scan() {
    document.querySelectorAll('.geo-product-express:not([data-geo-done])').forEach(build);
  }

  function start() {
    scan();
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
